export default __webpack_public_path__ + "static/media/KeysToMyWishes.ba845f90.mp4";